module.exports = __webpack_public_path__ + "img/looking into camera.031f4200.png";